import {GoogleDataLayer} from '../types/global'
import {Marketplace} from '../types/marketplace'

type GoogleAnalyticsEventName =
  | 'influx_cloud_signup_started'
  | 'influx_cloud_signup_success'

interface GoogleAnalyticsEventOptions {
  identity_provider: string
  marketplace?: Marketplace
}

interface Identity {
  id: string
  email: string
}

export interface AnalyticsClient {
  send_event(eventName: string, options: object)
  get_identity(): Identity
}

export class GoogleAnalyticsClient implements AnalyticsClient {
  private dataLayer: GoogleDataLayer
  private noOpDataLayer: GoogleDataLayer = {push: () => {}}

  constructor(dataLayer: GoogleDataLayer) {
    this.dataLayer = dataLayer || this.noOpDataLayer
  }

  send_event(
    eventName: GoogleAnalyticsEventName,
    options?: GoogleAnalyticsEventOptions
  ): void {
    const combinedOptions = {
      event: eventName,
      ...(options || {}),
    }

    this.dataLayer.push(combinedOptions)
  }

  get_identity(): Identity {
    const identity = Object.assign(
      {},
      this.dataLayer.filter((element) => {
        for (const key in element) {
          if (key === 'identity') {
            return true
          }
        }
        return false
      })[0] || {}
    )
    return identity['identity']
  }
}
